import React from "react";
import CustomButton from "../../Shared/CustomButton/CustomButton";
import "./TopBarButton.css"


type TopBarButtonProps = {
  text?: string,
  textClassName?: string,
  className: string,
  onClick: () => void
}


const TopBarButton = React.memo(function TopBarButton({ text, textClassName, className, onClick }: TopBarButtonProps) {
  return (
    <CustomButton className="button" onClick={() => onClick()}>
      <i className={className}></i>
      <span className={textClassName}>{text}</span>
    </CustomButton>
  )
})


export default TopBarButton